import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { setToken } from '../redux/features/authenSlice'; 
import { useEffect } from 'react';

const useAuth = () => {
  const dispatch = useDispatch();
  const { token: reduxToken } = useSelector(state => state.authen);
  const [cookies, setCookie, removeCookie] = useCookies(['token', 'userData']);

  const cookieToken = cookies.token;
  const token = reduxToken || cookieToken || localStorage.getItem("token");
  const isAuthenticated = !!token;

  
  useEffect(() => {
    if (!reduxToken && cookieToken) {
      dispatch(setToken(cookieToken));
    }
  }, [reduxToken, cookieToken, cookies.userData, dispatch]);

  return {
    isAuthenticated,
    token,
    setTokenCookie: setCookie,
    removeTokenCookie: removeCookie,
    tokenCookies: cookies, 
  };
};

export default useAuth;
